import { getSegmentAnalytics, track as curryTrack } from '@/segment';

/**
 * @deprecated Use `trackPage` from src/segment.ts instead.
 * Sends page data object to the dataLayer array in Segment.
 * @param {Object} data The tracking data object.
 * @return {boolean} Whether the tracking was successful or not.
 */
export function trackPage(
  args: {
    category?: string;
    name?: string;
    properties?: object;
    options?: object;
    callback?: () => void;
  } = {},
) {
  const { category, name, properties, options, callback } = args;
  const analytics = getSegmentAnalytics();

  if (!analytics) {
    return false;
  } else {
    // https://segment.com/docs/sources/website/analytics.js/#page
    analytics.page(category, name, properties, options, callback);
    return true;
  }
}

/**
 * @deprecated Use `trackWithSegment` instead.
 * Sends event data object to the dataLayer array in Segment.
 * @param {Object} data The tracking data object.
 * @return {boolean} Whether the tracking was successful or not.
 */
export function track(event, props = {}) {
  return curryTrack(event)(props);
}

/**
 * Formats the `filter` object $emit'd by LLFilters for Segment.
 * @param {object} state An object containing current applied filters
 * @param {string[]} multiple list of filters that accept multi-select
 */
export function trackable({ state, multiple }) {
  return Object.keys(state).reduce((acc, param) => {
    const value = state[param].filterBy;

    acc[param] = multiple.includes(param) || !Array.isArray(value) ? value : value[0];

    return acc;
  }, {});
}
